/*
 * @Author: your name
 * @Date: 2021-11-04 15:19:24
 * @LastEditTime: 2021-11-10 14:08:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /newwork-h5/src/permission.js
 */
import router from './router'
import { queryStaffToekn, koyoSSO, ovWxAutoLogin } from '@/services/api'
import { isNewworkAPPPlatform } from '@/utils/utils'
import { LocaleMgr } from './utils/i18n'

let isInitialized = false // 初始化

router.beforeEach(async (to, from, next) => {
  if (isNewworkAPPPlatform()) {
    document.title = to.meta ? to.meta.title : '' // 动态修改 title 用于 webview 中监听渲染 app 的 header
  }

  if (isInitialized) {
    // 初始化过了直接进入路由
    next()
    return
  }
  LocaleMgr._instance.setLocale(LocaleMgr.highestPriorityFirstLocale)

  if (window.injectData && window.injectData.token) {
    // NewWork app 登录
    const user = await queryStaffToekn({ token: window.injectData.token })
    localStorage.setItem('user', JSON.stringify(user))
    localStorage.setItem('cCode', JSON.stringify({ code: user.companyCode }))
    localStorage.setItem('companyCode', JSON.stringify({ code: user.companyCode }))
  }

  const { source, koyoToken, companyCode, appId, type } = to.query
  if (to.query.state !== 'fanwei' && (to.query.token || to.params.token)) {
    // url 上带了 token，通过 token 登录
    const user = JSON.parse(localStorage.getItem('user'))
    if (!user) {
      const newUser = await queryStaffToekn({ token: to.query.token || to.params.token })
      if (newUser && newUser.token) {
        localStorage.setItem('user', JSON.stringify(newUser))
        localStorage.setItem('cCode', JSON.stringify({ code: newUser.companyCode }))
        localStorage.setItem('companyCode', JSON.stringify({ code: newUser.companyCode }))
      }
    }
  }

  // TODO: 第三方登录的逻辑应该从登录页面移动到这里

  // 通祐免密登录
  if (source === 'koyo' && koyoToken) {
    window.injectData = { source: 'koyo' } // 用于实现沉静式，复用 NewWork app 的判断
    window.hideTabBar = true
    try {
      const nwToken = await koyoSSO(koyoToken)
      if (!!nwToken) {
        console.log('koyo sso success')
        const user = await queryStaffToekn({ token: nwToken })
        localStorage.setItem('user', JSON.stringify(user))
        localStorage.setItem('cCode', JSON.stringify({ code: user.companyCode }))
        localStorage.setItem('companyCode', JSON.stringify({ code: user.companyCode }))
      }
    } catch (err) {
      console.error('koyo sso failed', err)
    }
  }

  const FSautoLogin = async (code, companyCode) => {
    const res = await ovWxAutoLogin({
      companyCode: companyCode,
      fsOpenId: code,
    })
    if (res.id != -1) {
      localStorage.setItem('user', JSON.stringify(res))
      let companyCodeLocal = { code: companyCode }
      localStorage.setItem('cCode', JSON.stringify(companyCodeLocal))
      localStorage.setItem('companyCode', JSON.stringify(companyCodeLocal))
      if (res.name) {
        let check = JSON.parse(localStorage.getItem('checkMeeting'))
        let appointmentId = JSON.parse(localStorage.getItem('appointmentId'))
        if (check) {
          if (check.isTemplateSend) {
            router.replace(
              `templateSend?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
            )
          }
          if (check.isTemplateSendSpecial) {
            router.replace(
              `templateSendSpecial?appointmentId=${appointmentId.id}&companyCode=${companyCode}`
            )
          }
          localStorage.removeItem('checkMeeting')
          localStorage.removeItem('appointmentId')
          return
        }
        localStorage.removeItem('code')
        router.replace('/').catch(err => err)
      } else {
        router.replace('bindCompany')
      }
    }
  }

  if (type == 'feishu') {
    if (!window.h5sdk) {
      console.log('invalid h5sdk')
      // complete()
      return
    }
    window.h5sdk.ready(() => {
      // ready方法不需要每次都调用
      if (tt.requestAccess) {
        tt.requestAccess({
          scopeList: [],
          appID: appId,
          success: info => {
            FSautoLogin(info.code, companyCode)
          },
          fail: error => {
            console.error(error)
          },
        })
      } else {
        tt.requestAuthCode({
          appId: appId,
          success: info => {
            FSautoLogin(info.code, companyCode)
          },
          fail: error => {
            console.error(error)
          },
        })
      }
    })
  }
  isInitialized = true
  next()
})
